import React from 'react';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import Chip from '@material-ui/core/Chip';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import MapIcon from '@material-ui/icons/Map';
import MicIcon from '@material-ui/icons/Mic';
import SchoolIcon from '@material-ui/icons/School';
import SpeedIcon from '@material-ui/icons/Speed';
import VerifiedIcon from '@material-ui/icons/Verified';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Button from '@material-ui/core/Button';
import Container from 'common/Container';
import { EcosystemIntelligentDiagram } from './creatorsGuildAgendaShared';

const BrandTnoCon = ({ onDark = false, sxTno = {}, sxCon = {} }) => (
  <Box component="span" sx={{ whiteSpace: 'nowrap', display: 'inline' }}>
    <Box
      component="span"
      sx={{
        fontWeight: 900,
        letterSpacing: '-0.07em',
        textShadow:
          '0.02em 0 0 currentColor, -0.02em 0 0 currentColor, 0 0.02em 0 currentColor, 0 -0.02em 0 currentColor',
        ...sxTno,
      }}
    >
      TNO
    </Box>
    <Box
      component="span"
      sx={{
        fontWeight: 200,
        letterSpacing: '-0.07em',
        marginLeft: '-0.06em',
        color: onDark ? 'rgba(255,255,255,0.72)' : '#4a505c',
        ...sxCon,
      }}
    >
      CON
    </Box>
  </Box>
);

/** Agenda narrada del Creators Guild (presentación). */
const presentacionAgendaModulos = [
  {
    time: '10:00 AM',
    title: 'Módulo I: La Nueva Narrativa (El Speech)',
    isBreak: false,
    items: [
      { label: 'El Cambio', text: 'Dejamos de vender «espacios» para vender «territorios».' },
      {
        label: 'Propuesta',
        text: 'Aprenderás el guion exacto para que, cuando te pregunten qué es TNO, tu respuesta atraiga inversionistas.',
      },
      {
        label: 'Keynote',
        text: '«Si no puedes explicar tu ecosistema en 30 segundos, no eres el dueño de tu audiencia».',
      },
    ],
  },
  {
    time: '10:25 AM',
    title: 'Módulo II: Monetización 2.0 (El Negocio)',
    isBreak: false,
    items: [
      {
        label: 'Media Kits Dinámicos',
        text: 'Ya no enviarás un PDF pesado. Presentaremos el nuevo portal donde tus métricas hablan por ti.',
      },
      {
        label: 'Cross-Selling',
        text: 'Cómo vender un banner en el Digest y un slot en On-Demand como un paquete premium.',
      },
      {
        label: 'La Data Orgánica',
        text: 'Aprenderás a decirle a una marca: «No somos millones, somos los que TÚ necesitas».',
      },
    ],
  },
  {
    time: '10:50 AM',
    title: 'Break: networking creativo',
    isBreak: true,
    items: [{ label: '', text: 'Espacio breve para conectar con colegas y el equipo antes del cierre de la mañana.' }],
  },
  {
    time: '11:00 AM',
    title: 'Módulo III: Inteligencia Artificial (Tu Nueva Asistente)',
    isBreak: false,
    showDiagram: true,
    items: [
      {
        label: 'El Chatbot TNO',
        text:
          'Proyecto 2026: te lo contamos y lo enmarcamos en la experiencia del usuario, pero en esta sesión no habrá demo en vivo.',
      },
      {
        label: 'Algoritmos de Recomendación',
        text:
          'Proyecto 2026: explicación técnica (pero sencilla) de cómo la IA de TNO podrá enlazar intereses (p. ej. tecnología en el Digest) con tu programa en On-Demand; sin demostración en vivo hoy.',
      },
      {
        label: 'Productividad',
        text: 'Cómo usar la IA del Media Lab para que producir te tome la mitad del tiempo.',
      },
    ],
  },
  {
    time: '11:30 AM',
    title: 'Módulo IV: Del Micrófono al Texto (El Digest)',
    isBreak: false,
    items: [
      {
        label: 'Taller de Cierre',
        text:
          'Ejercicio práctico de cómo convertir tu mejor entrevista del día en un artículo de opinión que la gente pueda leer y compartir.',
      },
    ],
  },
];

const roadmapHitosPresentacion = [
  { phase: 'Q1', title: 'Orden en casa', detail: 'Definimos quién es quién y cómo suena TNO.' },
  { phase: 'Q2', title: 'La Caja de Herramientas', detail: 'Lanzamos las plantillas que harán que tus redes se vean de primer nivel sin esfuerzo extra.' },
  { phase: 'Q3', title: 'El Cerebro (IA)', detail: 'Encendemos los algoritmos. Tu contenido empieza a «moverse solo» dentro de la plataforma.' },
  { phase: 'Q4', title: 'Dominio Total', detail: 'Cerramos el año con métricas que demostrarán que somos la red más influyente del país.' },
];

const TALLER_LANDING_ADS_URL = 'https://ads.tnonetwork.com/tallerproduccion';

/** Calendario de formaciones 2026 (Media Lab) con Yelitza Yánez y Margarita Toledo. */
const mediaLabTalleresYelitzaMargarita2026 = [
  'Voz y dicción: lo que necesitas proyectar en cada programa o redes sociales',
  '¿Cómo producir un programa para multiplataforma?',
  'RRSS para emprendedores',
  'RRSS como imagen personal',
  'Géneros periodísticos y de opinión: ¿cómo llevarlos a la era digital?',
  'Conversatorio: las emociones dentro de un estudio de grabación',
  'Maquillaje e imagen personal (con Gladys Clavijo); Yeyé y Margarita de apoyo',
  'Taller de montaje y SEO',
  'Audio e iluminación: la introducción que necesitas',
  'IA para mejorar tu contenido',
];

const slideSectionSx = {
  minHeight: { xs: 'auto', md: '72vh' },
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  px: { xs: 0, md: 2, lg: 4 },
  py: { xs: 5, md: 8, lg: 10 },
};

/** Tipografía escalada para proyector / pantalla grande (toda la presentación). */
const deckOverlineSx = {
  color: '#6ee7a8',
  letterSpacing: { xs: 3, md: 5 },
  fontWeight: 800,
  fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem', lg: '1.15rem', xl: '1.2rem' },
  display: 'block',
  mb: 1,
};

const deckHeroTitleSx = {
  fontWeight: 900,
  lineHeight: { xs: 1.12, md: 1.08 },
  maxWidth: { md: 1000, lg: 1200 },
  fontSize: { xs: '2rem', sm: '2.35rem', md: '3rem', lg: '3.5rem', xl: '4rem' },
};

const deckHeroSubtitleSx = {
  mt: { xs: 2, md: 2.5 },
  maxWidth: { md: 920, lg: 1100, xl: 1200 },
  opacity: 0.92,
  fontWeight: 400,
  lineHeight: { xs: 1.65, md: 1.75, lg: 1.8 },
  fontSize: { xs: '1.1rem', sm: '1.2rem', md: '1.4rem', lg: '1.55rem', xl: '1.7rem' },
  color: 'common.white',
};

const deckHeadingSx = {
  fontWeight: 800,
  color: 'common.white',
  fontSize: { xs: '1.65rem', sm: '2rem', md: '2.5rem', lg: '3rem', xl: '3.25rem' },
  lineHeight: { xs: 1.2, md: 1.15 },
};

const deckSubheadingSx = {
  fontWeight: 800,
  color: 'common.white',
  fontSize: { xs: '1.45rem', sm: '1.75rem', md: '2.1rem', lg: '2.5rem', xl: '2.75rem' },
  lineHeight: 1.2,
};

const deckBodyLargeSx = {
  color: 'rgba(255,255,255,0.9)',
  lineHeight: { xs: 1.75, md: 1.85, lg: 1.9 },
  maxWidth: { xs: '100%', md: 920, lg: 1100, xl: 1200 },
  fontSize: { xs: '1.125rem', sm: '1.25rem', md: '1.45rem', lg: '1.65rem', xl: '1.8rem' },
  fontWeight: 400,
};

const deckCardTitleSx = {
  fontWeight: 800,
  mb: 1.5,
  fontSize: { xs: '1.1rem', sm: '1.2rem', md: '1.35rem', lg: '1.5rem', xl: '1.65rem' },
  lineHeight: 1.25,
  color: 'common.white',
};

const deckCardBodySx = {
  opacity: 0.92,
  lineHeight: { xs: 1.75, md: 1.85, lg: 1.9 },
  fontSize: { xs: '1rem', sm: '1.08rem', md: '1.22rem', lg: '1.38rem', xl: '1.5rem' },
  color: 'rgba(255,255,255,0.9)',
};

function CreatorsGuildRoadmapPresentation() {
  return (
    <Box sx={{ bgcolor: '#0a1812' }}>
      <Box
        sx={{
          background:
            'linear-gradient(165deg, rgba(6,22,14,0.98) 0%, rgba(18,72,48,0.96) 38%, rgba(34,140,95,0.55) 100%)',
          color: 'common.white',
          position: 'relative',
          overflow: 'hidden',
          '&:before': {
            content: '" "',
            position: 'absolute',
            inset: 0,
            background: 'radial-gradient(ellipse 80% 50% at 20% 0%, rgba(120,255,180,0.12), transparent 55%)',
            pointerEvents: 'none',
          },
        }}
      >
        <Container>
          <Box
            py={{ xs: 4, md: 6, lg: 8 }}
            px={{ xs: 0, md: 2, lg: 4 }}
            position="relative"
            zIndex={1}
          >
            <Chip
              icon={
                <MapIcon
                  sx={{
                    color: '#b8ffd0 !important',
                    fontSize: { xs: 22, md: 26, lg: 28 },
                  }}
                />
              }
              label={
                <span>
                  <BrandTnoCon onDark />
                  <Box component="span" sx={{ fontWeight: 700 }}> 2026 · Creators Guild</Box>
                </span>
              }
              sx={{
                mb: { xs: 2, md: 2.5 },
                color: 'common.white',
                bgcolor: 'rgba(255,255,255,0.1)',
                border: '1px solid rgba(180,255,210,0.25)',
                fontSize: { xs: '0.85rem', sm: '0.95rem', md: '1.05rem', lg: '1.15rem' },
                height: { xs: 36, md: 40, lg: 44 },
                '& .MuiChip-label': { px: { xs: 1.5, md: 2 } },
              }}
            />
            <Typography variant="h2" sx={{ color: 'common.white', ...deckHeroTitleSx }}>
              🚀 TNO CON 2026: Creators Guild
            </Typography>
            <Typography variant="subtitle1" component="p" sx={deckHeroSubtitleSx}>
              Presentación: El Salto al Ecosistema Inteligente
            </Typography>
          </Box>
        </Container>
      </Box>

      <Container>
        <Box sx={{ ...slideSectionSx, borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
          <Typography variant="overline" sx={deckOverlineSx}>
            1. El Gancho Inicial
          </Typography>
          <Typography variant="h4" component="h2" sx={{ ...deckHeadingSx, mb: { xs: 2, md: 2.5 } }}>
            ¿Por qué estamos hoy aquí?
          </Typography>
          <Box
            sx={{
              pl: { xs: 2, md: 2.5 },
              borderLeft: '4px solid',
              borderLeftColor: '#7af0b4',
              py: 1,
            }}
          >
            <Typography variant="body1" component="p" sx={{ ...deckBodyLargeSx, fontStyle: 'italic' }}>
              «El mundo ya no escucha radio, el mundo consume experiencias. Si tu contenido solo vive en el aire, está condenado a
              desaparecer cuando apagas el micrófono. Hoy, TNO evoluciona para que tu voz sea eterna, inteligente y rentable.»
            </Typography>
          </Box>
        </Box>
      </Container>

      <Box
        sx={{
          bgcolor: '#eef2f0',
          py: { xs: 4, md: 6 },
          minHeight: { xs: 'auto', md: '72vh' },
        }}
      >
        <Container>
          <Card
            variant="outlined"
            sx={{
              p: { xs: 2.5, md: 4 },
              bgcolor: 'rgba(46,125,50,0.08)',
              border: '2px solid',
              borderColor: 'primary.main',
              boxShadow: '0 8px 28px rgba(46,125,50,0.12)',
            }}
          >
            <Typography variant="overline" color="primary" sx={{ fontWeight: 800, letterSpacing: 2 }}>
              2. El Concepto
            </Typography>
            <Typography variant="h4" component="h2" sx={{ fontWeight: 800, color: 'primary.dark', mb: { xs: 2.5, md: 3 } }}>
              TNO Media Lab · de locutores a arquitectos de contenido
            </Typography>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              <Box
                sx={{
                  p: { xs: 2, md: 2.5 },
                  borderRadius: 1,
                  bgcolor: 'rgba(122, 240, 180, 0.14)',
                  border: '1px solid',
                  borderColor: 'primary.main',
                }}
              >
                <Typography variant="h6" sx={{ fontWeight: 800, color: 'primary.dark', mb: 1.5 }}>
                  ¿Qué es el TNO Media Lab?
                </Typography>
                <Typography variant="body1" color="textSecondary" sx={{ lineHeight: 1.85 }}>
                  El <strong>TNO Media Lab</strong> es el laboratorio de contenido y datos de TNO Network: donde se define cómo
                  suena, se ve y se distribuye la señal en un <strong>ecosistema multiplataforma</strong> (streaming, On-Demand,
                  Digest). Es el espacio donde talento, producción y tecnología comparten una misma narrativa y los mismos
                  estándares de calidad.
                </Typography>
              </Box>

              <Box
                sx={{
                  p: { xs: 2, md: 2.5 },
                  borderRadius: 1,
                  bgcolor: 'rgba(122, 240, 180, 0.14)',
                  border: '1px solid',
                  borderColor: 'primary.main',
                }}
              >
                <Typography variant="h6" sx={{ fontWeight: 800, color: 'primary.dark', mb: 1.5 }}>
                  ¿Cuál es el concepto?
                </Typography>
                <Typography variant="body1" color="textSecondary" sx={{ lineHeight: 1.85 }}>
                  El concepto apunta a que los comunicadores de la red sean <strong>arquitectos de contenido</strong>: dominar el
                  discurso oficial, las herramientas, el flujo de producción y la lectura comercial para que cada pieza funcione
                  de forma coherente en todas las superficies donde vive TNO. Es la misma idea que en Creators Guild: la jornada
                  intensiva del Media Lab donde el talento <strong>profesionaliza el ADN TNO</strong>.
                </Typography>
              </Box>

              <Box
                sx={{
                  p: { xs: 2, md: 2.5 },
                  borderRadius: 1,
                  bgcolor: 'rgba(255, 236, 224, 0.92)',
                  border: '1px dashed',
                  borderColor: 'rgba(198, 40, 40, 0.42)',
                }}
              >
                <Typography variant="body1" color="textSecondary" sx={{ lineHeight: 1.85, mb: 2 }}>
                  En 2026, eliminamos la palabra «programa» de nuestro vocabulario interno. Ahora creamos{' '}
                  <strong>Ecosistemas de Valor</strong>.
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: 800, color: 'primary.dark', mb: 1.5 }}>
                  Las tres superficies del ecosistema
                </Typography>
                <Box component="ul" sx={{ m: 0, pl: 2.5, color: 'text.secondary' }}>
                  <li>
                    <Typography variant="body1" color="textSecondary" sx={{ lineHeight: 1.8 }}>
                      <Box component="span" sx={{ fontWeight: 800, color: 'primary.main' }}>
                        Streaming:{' '}
                      </Box>
                      El impacto del «ahora».
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="body1" color="textSecondary" sx={{ lineHeight: 1.8, mt: 1.25 }}>
                      <Box component="span" sx={{ fontWeight: 800, color: 'primary.main' }}>
                        On-Demand:{' '}
                      </Box>
                      Tu biblioteca personal de autoridad.
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="body1" color="textSecondary" sx={{ lineHeight: 1.8, mt: 1.25 }}>
                      <Box component="span" sx={{ fontWeight: 800, color: 'primary.main' }}>
                        Digest:{' '}
                      </Box>
                      Tu legado intelectual y SEO.
                    </Typography>
                  </li>
                </Box>
              </Box>
            </Box>
          </Card>
        </Container>
      </Box>

      <Box sx={{ bgcolor: '#eef2f0', py: { xs: 4, md: 6 } }}>
        <Container>
          <Box py={{ xs: 0, md: 1 }}>
            <Typography variant="overline" color="primary" sx={{ fontWeight: 800, letterSpacing: 2 }}>
              3. Agenda desarrollada
            </Typography>
            <Typography variant="h3" sx={{ fontWeight: 800, mb: 1, color: 'primary.dark' }}>
              Lo que vamos a dominar hoy
            </Typography>
            <Typography variant="body1" color="textSecondary" sx={{ mb: 3, maxWidth: 900, lineHeight: 1.85 }}>
              Lunes 20 de abril · Día 1 de <BrandTnoCon /> · Creators Guild · <strong>10:00 a. m. – 12:00 m.</strong> (jornada
              intensiva de mañana)
            </Typography>
            <Grid container spacing={3}>
              {presentacionAgendaModulos.map((mod) => (
                <Grid item xs={12} key={mod.title}>
                  <Card
                    variant="outlined"
                    sx={{
                      p: { xs: 2, md: 3 },
                      ...(mod.isBreak ? { bgcolor: 'alternate.main', borderStyle: 'dashed' } : {}),
                    }}
                  >
                    <Grid container spacing={2} alignItems="flex-start">
                      <Grid item xs={12} sm={3} md={2}>
                        <Chip label={mod.time} color={mod.isBreak ? 'default' : 'primary'} sx={{ fontWeight: 800 }} />
                      </Grid>
                      <Grid item xs={12} sm={9} md={10}>
                        <Typography variant="h6" sx={{ fontWeight: 800, color: 'text.primary', mb: 2 }}>
                          {mod.title}
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.75 }}>
                          {mod.items.map((row) => (
                            <Box key={`${mod.title}-${row.label}-${row.text}`}>
                              {row.label ? (
                                <Typography component="span" variant="body1" sx={{ fontWeight: 700, color: 'text.primary' }}>
                                  {row.label}:{' '}
                                </Typography>
                              ) : null}
                              <Typography component="span" variant="body1" color="textSecondary" sx={{ lineHeight: 1.75 }}>
                                {row.text}
                              </Typography>
                            </Box>
                          ))}
                        </Box>
                        {mod.showDiagram ? (
                          <Box sx={{ mt: 2 }}>
                            <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mb: 1.5, lineHeight: 1.65 }}>
                              Referencia visual del ecosistema (roadmap 2026); no es una demostración en vivo del producto.
                            </Typography>
                            <EcosystemIntelligentDiagram />
                          </Box>
                        ) : null}
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Container>
      </Box>

      <Container>
        <Box sx={{ ...slideSectionSx, borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
          <Typography variant="overline" sx={deckOverlineSx}>
            4. Roadmap tecnológico
          </Typography>
          <Typography variant="h4" sx={{ ...deckSubheadingSx, mb: { xs: 2, md: 3 } }}>
            Hitos reales
          </Typography>
          <Timeline position="right" sx={{ [`& .MuiTimelineItem-missingOppositeContent:before`]: { flex: 0, px: 0 } }}>
            {roadmapHitosPresentacion.map((m, i) => (
              <TimelineItem key={m.phase}>
                <TimelineOppositeContent
                  sx={{
                    flex: { xs: 0.35, md: 0.22 },
                    maxWidth: { xs: 100, md: 140, lg: 160 },
                    minWidth: { xs: 72, md: 100 },
                    color: '#7af0b4',
                    fontWeight: 800,
                    fontSize: { xs: '0.95rem', sm: '1.05rem', md: '1.2rem', lg: '1.35rem', xl: '1.45rem' },
                    pt: { md: 0.5 },
                  }}
                >
                  {m.phase}
                </TimelineOppositeContent>
                <TimelineSeparator>
                  <TimelineDot
                    sx={{
                      bgcolor: '#228c5f',
                      boxShadow: '0 0 0 4px rgba(34,140,95,0.35)',
                      width: { xs: 36, md: 42, lg: 46 },
                      height: { xs: 36, md: 42, lg: 46 },
                      margin: { xs: '6px 0', md: '8px 0' },
                    }}
                  >
                    <SpeedIcon sx={{ fontSize: { xs: 20, md: 24, lg: 26 }, color: 'common.white' }} />
                  </TimelineDot>
                  {i < roadmapHitosPresentacion.length - 1 ? (
                    <TimelineConnector sx={{ bgcolor: 'rgba(120,255,180,0.25)', minHeight: { xs: 24, md: 32 } }} />
                  ) : null}
                </TimelineSeparator>
                <TimelineContent sx={{ py: { xs: 1.5, md: 2 }, pl: { xs: 1, md: 2 } }}>
                  <Typography variant="h6" sx={deckCardTitleSx}>
                    {m.title}
                  </Typography>
                  <Typography variant="body2" sx={{ ...deckCardBodySx, mt: { xs: 1, md: 1.25 } }}>
                    {m.detail}
                  </Typography>
                </TimelineContent>
              </TimelineItem>
            ))}
          </Timeline>
        </Box>
      </Container>

      <Box sx={{ bgcolor: '#eef2f0', py: { xs: 4, md: 6 } }}>
        <Container>
          <Card
            variant="outlined"
            sx={{
              p: { xs: 2.5, md: 4 },
              bgcolor: 'rgba(46,125,50,0.08)',
              border: '2px solid',
              borderColor: 'primary.main',
              boxShadow: '0 8px 28px rgba(46,125,50,0.12)',
            }}
          >
            <Typography variant="overline" color="primary" sx={{ fontWeight: 800, letterSpacing: 2 }}>
              5. TNO Media Lab
            </Typography>
            <Typography variant="h4" sx={{ fontWeight: 800, color: 'primary.dark', mb: 2 }}>
              Tu entrenamiento de élite
            </Typography>
            <Typography variant="body1" color="textSecondary" sx={{ lineHeight: 1.9, mb: { xs: 2.5, md: 3 } }}>
              No te dejamos solo. El Media Lab inicia un ciclo de formación continua con <strong>Margarita Toledo</strong> y{' '}
              <strong>Yelitza Yánez</strong>.
            </Typography>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              <Box
                sx={{
                  p: { xs: 2, md: 2.5 },
                  borderRadius: 1,
                  bgcolor: 'rgba(122, 240, 180, 0.14)',
                  border: '1px solid',
                  borderColor: 'primary.main',
                }}
              >
                <Box display="flex" gap={{ xs: 1.5, md: 2 }} alignItems="flex-start">
                  <SchoolIcon sx={{ fontSize: { xs: 36, md: 42 }, color: 'primary.main', flexShrink: 0, mt: 0.25 }} />
                  <Box>
                    <Typography variant="h6" sx={{ fontWeight: 800, color: 'primary.dark', mb: 1.5 }}>
                      Formaciones
                    </Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ lineHeight: 1.8, mb: 1.5 }}>
                      Habrá <strong>formaciones continuas</strong> después del Creators Guild: módulos prácticos alineados con la
                      operación real del Media Lab, nuevas herramientas y actualizaciones de plataforma para que el talento siga
                      creciendo con la red.
                    </Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ lineHeight: 1.8, mb: 1 }}>
                      <strong>Especialización:</strong> desde el uso de IA hasta el lenguaje corporal y SEO.
                    </Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ lineHeight: 1.8 }}>
                      <strong>Beneficio:</strong> precios exclusivos por ser parte de la «Guild» de TNO.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{
                  p: { xs: 2, md: 2.5 },
                  borderRadius: 1,
                  bgcolor: 'rgba(255, 236, 224, 0.92)',
                  border: '1px dashed',
                  borderColor: 'rgba(198, 40, 40, 0.42)',
                }}
              >
                <Box display="flex" gap={{ xs: 1.5, md: 2 }} alignItems="flex-start">
                  <MicIcon sx={{ fontSize: { xs: 36, md: 42 }, color: 'error.main', flexShrink: 0, mt: 0.25 }} />
                  <Box flex={1} minWidth={0}>
                    <Typography variant="h6" sx={{ fontWeight: 800, color: 'text.primary', mb: 0.5 }}>
                      Taller de producción (landing aparte)
                    </Typography>
                    <Typography variant="subtitle2" sx={{ fontWeight: 800, color: 'primary.dark', mb: 1 }}>
                      Plan de talleres 2026
                    </Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ lineHeight: 1.8, mb: 1.5 }}>
                      El taller lo imparten <strong>Margarita Toledo</strong> y <strong>Yelitza Yánez (Yelita)</strong>: técnica
                      en estudio y post, flujo de trabajo y estándares para elevar la calidad de tus entregas. Toda la
                      información, mentores y registro están en su propia página.
                    </Typography>
                    <Box
                      component="ol"
                      sx={{
                        m: 0,
                        mb: 2,
                        pl: 2.25,
                        color: 'text.secondary',
                        '& li': { mb: 0.75 },
                      }}
                    >
                      {mediaLabTalleresYelitzaMargarita2026.map((tema) => (
                        <li key={tema}>
                          <Typography component="span" variant="body2" color="textSecondary" sx={{ lineHeight: 1.7 }}>
                            {tema}
                          </Typography>
                        </li>
                      ))}
                    </Box>
                    <Button
                      variant="contained"
                      color="primary"
                      href={TALLER_LANDING_ADS_URL}
                      target="_blank"
                      rel="noreferrer"
                      endIcon={<ChevronRightIcon />}
                      sx={{ fontWeight: 800, textTransform: 'none' }}
                    >
                      Ir al taller de producción
                    </Button>
                    <Typography variant="body2" color="textSecondary" sx={{ mt: 2, fontWeight: 700 }}>
                      URL principal:{' '}
                      <Link href={TALLER_LANDING_ADS_URL} target="_blank" rel="noreferrer" color="primary">
                        {TALLER_LANDING_ADS_URL}
                      </Link>
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Card>
        </Container>
      </Box>

      <Box sx={{ bgcolor: 'rgba(255,255,255,0.03)' }}>
        <Container>
          <Box sx={slideSectionSx}>
            <Typography variant="overline" sx={deckOverlineSx}>
              Compromiso
            </Typography>
            <Typography variant="h4" sx={{ ...deckSubheadingSx, mb: { xs: 2, md: 3 } }}>
              Qué esperamos del gremio
            </Typography>
            <Grid container spacing={{ xs: 2, md: 3 }}>
              {[
                'Participar en los checkpoints trimestrales con feedback honesto.',
                'Adoptar los flujos Media Lab cuando estén en producción; reportar fricción temprano.',
                'Cuidar la consistencia de marca y tono en cada superficie donde aparezca tu voz.',
              ].map((line) => (
                <Grid item xs={12} key={line}>
                  <Box display="flex" alignItems="flex-start" gap={{ xs: 1.5, md: 2 }}>
                    <VerifiedIcon
                      sx={{
                        color: '#7af0b4',
                        mt: { xs: 0.35, md: 0.5 },
                        fontSize: { xs: 28, md: 32, lg: 36 },
                        flexShrink: 0,
                      }}
                    />
                    <Typography sx={{ ...deckBodyLargeSx, color: 'rgba(255,255,255,0.9)' }}>{line}</Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Container>
      </Box>
    </Box>
  );
}

export default CreatorsGuildRoadmapPresentation;
